import { PayloadAction } from '@reduxjs/toolkit';

import { LivePreviewState } from '../types';

const setExpandedWidthReducer = (state: LivePreviewState, action: PayloadAction<number | undefined>) => {
  state.expandedWidth = action.payload;
};

export default setExpandedWidthReducer;
